import React from "react";

export const RuoBanner = () => (
  <div
    data-testid="ruo-banner"
    className="fixed top-0 left-0 right-0 z-[60] bg-ruo text-cream"
  >
    <div className="overflow-hidden whitespace-nowrap py-1.5">
      <div className="inline-flex animate-marquee">
        {[0, 1].map((k) => (
          <span key={k} className="font-mono text-[11px] tracking-[0.25em] uppercase">
            {Array.from({ length: 8 }).map((_, i) => (
              <span key={i} className="mx-6">
                Research Use Only &nbsp;•&nbsp; Not For Human Consumption &nbsp;•&nbsp; Not A Drug
              </span>
            ))}
          </span>
        ))}
      </div>
    </div>
  </div>
);
